module.exports = __webpack_public_path__ + "img/goods3_5.68116549.jpg";